var bMobile, // true if in mobile mode
    headerHeight = jQuery('#header').height(),
    hovering = false;

function setHeaderHeight(setIt) {
  if (jQuery('.navbar-toggle').is(':visible')) {
    headerHeight = 76;
  } else {
    if ($(window).scrollTop() < headerHeight) {
      headerHeight = 130;
    } else {
      headerHeight = 110;
    }
  }
  if (hovering===false) {
    $('#header').css('height', headerHeight);
  }
}

// Initiate event handlers
function init() {
    'use strict';
    // .navbar-toggle is only visible in mobile mode
    bMobile = jQuery('.navbar-toggle').is(':visible');
    var oMenus = jQuery('.navbar-nav .dropdown'),
        nTimer;
    if (bMobile) {
        // Disable hover events for mobile
        oMenus.off();
        setHeaderHeight();
    } else {
        // $('body').on('mouseenter mouseleave', '.dropdown', e => $(e.target).dropdown('toggle'));
        var blocked = false;
        $('#header').on('mouseenter', '.dropdown', function(e) {
            hovering = true;
            setHeaderHeight();
            var dropdown = $(e.target).closest('.dropdown'),
                menu = $('.dropdown-menu', dropdown),
                menuStart = $('#main-nav').offset().top - $(window).scrollTop() + 44,
                menuHeight = menu.innerHeight();
            $('#header').css('height', Math.max(menuStart + menuHeight, headerHeight));
            dropdown.addClass('show');
            menu.addClass('show');
            if (!blocked && $('.dropdown.show').length < 1) {
              blocked = true;
              setTimeout(function() {
                  dropdown.addClass('show');
                  menu.addClass('show');
              }, 300);
              setTimeout(function() {
                blocked = false;
              }, 500);
            }
        });

        $('#header').on('mouseleave', '.dropdown', function() {
          hovering = false;
          $('#header').css('height', headerHeight);
          $('.dropdown').removeClass('show');
          $('.dropdown-menu').removeClass('show');
        });
    }
}

jQuery(document).ready(function($) {
    init();

    $(window).resize(init);

    $('.open-search').on('click', function() {
        $('.search-panel').slideDown(400, function() {
          $('.search-panel').addClass('is-active');
          $('html').addClass('no-scroll');
          $('input#site-search-keyword').focus();
        });
    });

    $('.close-search').on('click', function() {
        $('.search-panel').removeClass('is-active');
        $('.search-panel').slideUp(400, function() {
          $('html').removeClass('no-scroll');
        });
    });

    $(document).on('keyup', function(e) {
      var evt = e || window.event, isEsc = false;
      if ("key" in evt) {
        isEsc = (evt.key==='Escape' || evt.key==='Esc');
      } else {
        isEsc = (evt.keyCode === 27);
      }
      if (isEsc) {
        if ($('.search-panel').hasClass('is-active')) {
          $('.search-panel').removeClass('is-active');
          $('.search-panel').slideUp(400, function() {
            $('html').removeClass('no-scroll');
          });
        }
      }
    });
});

jQuery(window).on('scroll', function() {
  setHeaderHeight();
});
